<a>
  <span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span>
  <span class="second-column" ng-bind-html="match.model.employeeOrgUnitName | uibTypeaheadHighlight:query"></span>
</a>
